/**
 * Returns the legalActions array for the current pendingActor, or an
 * empty array when no hand is active. Pure selector — does not mutate
 * store state.
 */
import { useMemo } from 'react';
import { legalActions } from '@/engine/rules';
import type { LegalAction, PlayerId } from '@/engine/types';
import { useGameStore } from '@/state/gameStore';

export function useLegalActions(actorId: PlayerId | null): ReadonlyArray<LegalAction> {
  const hand = useGameStore((s) => s.hand);
  return useMemo(() => {
    if (!hand || !actorId || hand.pendingActor !== actorId) return [];
    return legalActions(hand, actorId);
  }, [hand, actorId]);
}
